// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kn-0";